import { YearEvent } from "../YearEvent/YearEvent";

export const ListOfEvents = ({ events }) => {
	return (
		<section className="event__component">
			<div className="event__component-wrap">
				{events.map((event) => (
					<YearEvent
						key={event.id}
						{...event}
					/>
				))}
			</div>
		</section>
	);
};
